import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
  Container,
  Button,
  FormGroup,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from '@mui/material';
import logoCrevettic2 from '../../images/logo1.1.png';
import logoBludocc2 from '../../images/bludocc-logo2.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ReCAPTCHA from 'react-google-recaptcha';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { setNameProperty } from '../../redux/nameProperty';
import { setNameUser } from '../../redux/nameUser';
import { setAuthentication } from '../../redux/authenticated';
import { useStyles } from '../../components/Styles';
import axios from 'axios';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const history = useHistory();
    return <Component history={history} {...props} />;
  }
  return Wrapper;
};

function IconWithTooltipSenha() {
  return (
    <Tooltip
      title="A senha deve conter ao menos 6 caracters. A senha deve conter ao menos uma letra minúscula, uma letra maíscula e um número."
      placement="right"
      arrow
    >
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ConfirmInvite(props) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.authenticated.authenticated
  );

  const [isInvite, setIsInvite] = useState(isAuthenticated);
  const classes = useStyles();
  const history = useHistory();
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [showSend, setShowSend] = React.useState(false);
  const [showSend2, setShowSend2] = React.useState(false);
  const [openDia, setOpenDia] = React.useState(false);
  const { invite } = useParams();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [openError, setOpenError] = useState(false);
  const [scroll, setScroll] = useState('paper');
  const [openCancelar, setOpenCancelar] = useState(false);
  const [openDialogError, setOpenDialogError] = useState(false);

  useEffect(() => {
    if (!invite) {
      setOpenDia(true);
    }
  }, [invite]);

  const formik = useFormik({
    initialValues: {
      username: '',
      invite: '',
      password: '',
      password_confirmation: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Campo Obrigatório'),
      password: Yup.string()
        .matches(
          /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/,
          'A senha deve conter ao menos uma letra minúscula, uma letra maiúscula e um número'
        )
        .min(6, 'A senha deve conter ao menos 6 caracteres')
        .required('Campo Obrigatório'),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais!')
        .required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      request(values);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  async function request(data) {
    try {
      const api = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
      });
      // const { username, email, password } = data;
      if (invite) {
        data.invite = invite;
        await api.post('/users/confirm', { ...data });
      } else {
        alert('Conta não registrada');
      }
      history.push('/signin');
    } catch (err) {
      setOpenDialogError(true);
    }
  }

  function handleCloseDia() {
    setOpenDia(false);
  }

  function handleCloseDialogError() {
    setOpenDialogError(false);
  }

  function handleCancelTerms() {
    setOpenCancelar(true);
  }

  function onChangeRecaptcha(value) {
    setShowSend(true);
    handleClickOpenTerms('body');
  }

  function onChangeTerms(value) {
    setShowSend2(true);
  }

  const handleClickOpenTerms = (scrollType) => () => {
    setOpen2(true);
    setScroll(scrollType);
  };

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
    setOpenCancelar(false);
  }

  function handleLogout() {
    // logout2();
    dispatch(setNameProperty(''));
    dispatch(setNameUser(''));
    dispatch(setAuthentication(false));
    // history.replace("/");
  }

  const handleCloseTerms = (event, reason) => {
    setOpen2(false);

    setShowSend2(true);
    setOpenCancelar(false);
  };

  return (
    <div>
      <Container>
        <div>
          <Dialog
            open={openDialogError}
            onClose={() => {
              history.push('/signin');
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Não foi possível cadastar a senha pois este token já foi utilizado
              ou expiroui, solicite outro ao administador do sistema .
            </DialogTitle>
            <DialogActions>
              <Button
                onClick={() => {
                  history.push('/signin');
                }}
                variant="outlined"
              >
                Entendi
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div>
          <Dialog
            open={openDia}
            onClose={handleCloseDia}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Confirmação Necessária.
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Espere nossa equipe entrar em contato com você para validar o
                seu cadastro.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDia} variant="contained">
                Entendo
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <form className={classes.root} onSubmit={formik.handleSubmit}>
          <Typography
            style={{ marginBottom: 0 }}
            variant="h6"
            align="center"
            gutterBottom
          >
            <img
              alt="Logo"
              style={{ maxHeight: '120px' }}
              src={
                process.env.REACT_APP_PLATAFORM === 'crevettic'
                  ? logoCrevettic2
                  : logoBludocc2
              }
            />
          </Typography>
          <FormGroup>
            <TextField
              id="formGridName"
              label="Nome de Usuário"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="username"
              placeholder="Nome de usuário"
              type="text"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.username && formik.errors.username}
              helperText={
                formik.touched.username &&
                formik.errors.username &&
                formik.errors.username
              }
            />
          </FormGroup>

          <FormGroup>
            <TextField
              InputLabelProps={{
                style: { pointerEvents: 'auto' },
                shrink: true,
              }}
              id="formGridResp"
              label={
                <div>
                  Senha
                  <IconWithTooltipSenha />
                </div>
              }
              variant="outlined"
              name="password"
              placeholder="Senha"
              type={showPassword ? 'text' : 'password'}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={formik.touched.password && formik.errors.password}
              helperText={
                formik.touched.password &&
                formik.errors.password &&
                formik.errors.password
              }
            />
          </FormGroup>

          <FormGroup>
            <TextField
              id="formGridResp"
              label="Confirmar senha"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="password_confirmation"
              placeholder="Senha"
              type={showConfirmPassword ? 'text' : 'password'}
              value={formik.values.password_confirmation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={
                formik.touched.password_confirmation &&
                formik.errors.password_confirmation
              }
              helperText={
                formik.touched.password_confirmation &&
                formik.errors.password_confirmation &&
                formik.errors.password_confirmation
              }
            />
          </FormGroup>
          {showSend2 && (
            <ReCAPTCHA
              className={classes.recaptcha}
              sitekey={
                process.env.REACT_APP_PLATAFORM === 'crevettic'
                  ? '6LeOkXYdAAAAAMXuoD12Qm6yUzZyZwIRewCy_zCT'
                  : '6LcvnXYdAAAAAFd-l9KbUs3YmADoBJs-iBBe_xjZ'
              }
              onChange={onChangeRecaptcha}
            />
          )}

          <Dialog
            open={open2}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title">
              Termos de uso do sistema
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                ref={descriptionElementRef}
                tabIndex={-1}
              >
                <Typography variant="h6" component="h6">
                  Os serviços do Crevettic são fornecidos pela pessoa jurídica
                  OU física com a seguinte Razão Social/nome: Crevettic, com
                  nome fantasia Crevettic Servicos Ltda, inscrito no CNPJ/CPF
                  sob o nº 38.730.201/0001-17, titular da propriedade
                  intelectual sobre software, website, aplicativos, conteúdos e
                  demais ativos relacionados à plataforma Crevettic.
                </Typography>

                <Typography variant="h6" component="h6" gutterBottom>
                  1. Do objeto
                </Typography>
                {`
A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de propriedade intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos seus usuários.
A plataforma caracteriza-se pela prestação do seguinte serviço: Plataforma Inteligente de Monitoramento e Avaliação da Saúde do Camarão..

`}
                <Typography variant="h6" component="h6" gutterBottom>
                  2. Da aceitação
                </Typography>
                {`
O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por tempo indeterminado, entre a plataforma e as pessoas físicas ou jurídicas, usuárias da plataforma.
Ao utilizar a plataforma o usuário aceita integralmente as presentes normas e compromete-se a observá-las, sob o risco de aplicação das penalidade cabíveis.
A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de quaisquer serviços fornecidos pela empresa. Caso não concorde com as disposições deste instrumento, o usuário não deve utilizá-los.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  3. Do acesso dos usuários
                </Typography>
                {`
Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por semana. No entanto, a navegação na plataforma ou em alguma de suas páginas poderá ser interrompida, limitada ou suspensa para atualizações, modificações ou qualquer ação necessária ao seu bom funcionamento.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  4. Do cadastro
                </Typography>
                {`
O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio e, a depender dos serviços ou produtos escolhidos, o pagamento de determinado valor.
Ao se cadastrar o usuário deverá informar dados completos, recentes e válidos, sendo de sua exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se compromete com a veracidade dos dados fornecidos.
O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.
Menores de 18 anos e aqueles que não possuírem plena capacidade civil deverão obter previamente o consentimento expresso de seus responsáveis legais para utilização da plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva dos mesmos o eventual acesso por menores de idade e por aqueles que não possuem plena capacidade civil sem a prévia autorização.
Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente capaz, podendo exercer e usufruir livremente dos serviços e produtos.
O usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará todas comunicações necessárias.
Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual assegura ao usuário o acesso individual à mesma. Desta forma, compete ao usuário exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o acesso indevido às informações pessoais.
Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário, que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.
Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é pessoal e intransferível.
Caberá ao usuário assegurar que o seu equipamento seja compatível com as características técnicas que viabilize a utilização da plataforma e dos serviços ou produtos.
O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro junto a plataforma. O seu descadastramento será realizado o mais rapidamente possível, desde que não sejam verificados débitos em aberto.
O usuário, ao aceitar os Termos e Política de Privacidade, autoriza expressamente a plataforma a coletar, usar, armazenar, tratar, ceder ou utilizar as informações derivadas do uso dos serviços, do site e quaisquer plataformas, incluindo todas as informações preenchidas pelo usuário no momento em que realizar ou atualizar seu cadastro, além de outras expressamente descritas na Política de Privacidade que deverá ser autorizada pelo usuário.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  5. Dos serviços ou produtos
                </Typography>
                {`
A plataforma poderá disponibilizar para o usuário um conjunto específico de funcionalidades e ferramentas para otimizar o uso dos serviços e produtos.
Na plataforma os serviços ou produtos oferecidos estão descritos e apresentados com o maior grau de exatidão, contendo informações sobre suas características, qualidades, quantidades, composição, preço, garantia, prazos de validade e origem, entre outros dados, bem como sobre os riscos que apresentam à saúde e segurança do usuário.
Antes de finalizar a compra sobre determinado produto ou serviço, o usuário deverá se informar sobre as suas especificações e sobre a sua destinação.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  6. Dos preços
                </Typography>
                {`
A plataforma se reserva no direito de reajustar unilateralmente, a qualquer tempo, os valores dos serviços ou produtos sem consulta ou anuência prévia do usuário.
Os valores aplicadas são aqueles que estão em vigor no momento do pedido.
Os preços são indicados em reais e não incluem as taxas de entrega, as quais são especificadas à parte e são informadas ao usuário antes da finalização do pedido.
Na contratação de determinado serviço ou produto, a plataforma poderá solicitar as informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao inserir referidos dados o usuário concorda que sejam cobrados, de acordo com a forma de pagamento que venha a ser escolhida, os preços então vigentes e informados quando da contratação. Referidos dados financeiros poderão ser armazenadas para facilitar acessos e contratações futuras.
A contratação dos serviços será renovada automaticamente pela plataforma, independentemente de comunicação ao usuário, mediante cobrança periódica da mesma forma de pagamento indicada pelo usuário quando da contratação do serviço.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  7. Do cancelamento
                </Typography>
                {`
O usuário poderá cancelar a contratação dos serviços de acordo com os termos que forem definidos no momento de sua contratação. Ainda, o usuário também poderá cancelar os serviços em até 7 (sete) dias após a contratação, mediante contato com a Crevettic, de acordo com o Código de Defesa do Consumidor (Lei no. 8.078/90).
O serviço poderá ser cancelado por:
a) parte do usuário: nessas condições os serviços somente cessarão quando concluído o ciclo vigente ao tempo do cancelamento;
b) violação dos Termos de Uso: os serviços serão cessados imediatamente.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  8. Do suporte
                </Typography>
                {`
Em caso de qualquer dúvida, sugestão ou problema com a utilização da plataforma, o usuário poderá entrar em contato com o suporte, através do email crevettic@gmail.com OU telefone 88992146020.
Estes serviços de atendimento ao usuário estarão disponíveis nos seguintes dias e horários: Segunda a sexta - 8h as 18h.
9. Das responsabilidades
É de responsabilidade do usuário:
a) defeitos ou vícios técnicos originados no próprio sistema do usuário;
b) a correta utilização da plataforma, dos serviços ou produtos oferecidos, prezando pela boa convivência, pelo respeito e cordialidade entre os usuários;
c) pelo cumprimento e respeito ao conjunto de regras disposto nesse Termo de Condições Geral de Uso, na respectiva Política de Privacidade e na legislação nacional e internacional;
d) pela proteção aos dados de acesso à sua conta/perfil (login e senha).
É de responsabilidade da plataforma Crevettic:
a) indicar as características do serviço ou produto;
b) os defeitos e vícios encontrados no serviço ou produto oferecido desde que lhe tenha dado causa;
c) as informações que foram por ele divulgadas, sendo que os comentários ou informações divulgadas por usuários são de inteira responsabilidade dos próprios usuários;
d) os conteúdos ou atividades ilícitas praticadas através da sua plataforma.
A plataforma não se responsabiliza por links externos contidos em seu sistema que possam redirecionar o usuário ao ambiente externo a sua rede.
Não poderão ser incluídos links externos ou páginas que sirvam para fins comerciais ou publicitários ou quaisquer informações ilícitas, violentas, polêmicas, pornográficas, xenofóbicas, discriminatórias ou ofensivas.

`}
                <Typography variant="h6" component="h6" gutterBottom>
                  10. Dos direitos autorais
                </Typography>
                {`
O presente Termo de Uso concede aos usuários uma licença não exclusiva, não transferível e não sublicenciável, para acessar e fazer uso da plataforma e dos serviços e produtos por ela disponibilizados.
A estrutura do site ou aplicativo, as marcas, logotipos, nomes comerciais, layouts, gráficos e design de interface, imagens, ilustrações, fotografias, apresentações, vídeos, conteúdos escritos e de som e áudio, programas de computador, banco de dados, arquivos de transmissão e quaisquer outras informações e direitos de propriedade intelectual da razão social 38.730.201/0001-17, observados os termos da Lei da Propriedade Industrial (Lei nº 9.279/96), Lei de Direitos Autorais (Lei nº 9.610/98) e Lei do Software (Lei nº 9.609/98), estão devidamente reservados.
Este Termos de Uso não cede ou transfere ao usuário qualquer direito, de modo que o acesso não gera qualquer direito de propriedade intelectual ao usuário, exceto pela licença limitada ora concedida.
O uso da plataforma pelo usuário é pessoal, individual e intransferível, sendo vedado qualquer uso não autorizado, comercial ou não-comercial. Tais usos consistirão em violação dos direitos de propriedade intelectual da razão social ___, puníveis nos termos da legislação aplicável.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  11. Das sanções
                </Typography>
                {`
Sem prejuízo das demais medidas legais cabíveis, a razão social 38.730.201/0001-17 poderá, a qualquer momento, advertir, suspender ou cancelar a conta do usuário:
a) que violar qualquer dispositivo do presente Termo;
b) que descumprir os seus deveres de usuário;
c) que tiver qualquer comportamento fraudulento, doloso ou que ofenda a terceiros.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  12. Da rescisão
                </Typography>
                {`
A não observância das obrigações pactuadas neste Termo de Uso ou da legislação aplicável poderá, sem prévio aviso, ensejar a imediata rescisão unilateral por parte da razão social 38.730.201/0001-17 e o bloqueio de todos os serviços prestados ao usuário.
14. Das alterações
Os itens descritos no presente instrumento poderão sofrer alterações, unilateralmente e a qualquer tempo, por parte da Crevettic, para adequar ou modificar os serviços, bem como para atender novas exigências legais. As alterações serão veiculadas OU pela plataforma e o usuário poderá optar por aceitar o novo conteúdo ou por cancelar o uso dos serviços, caso seja assinante de algum serviço.
Os serviços oferecidos podem, a qualquer tempo e unilateralmente, e sem qualquer aviso prévio, ser deixados de fornecer, alterados em suas características, bem como restringido para o uso ou acesso.
`}
                <Typography variant="h6" component="h6" gutterBottom>
                  13. Da política de privacidade
                </Typography>
                {`
Além do presente Termo, o usuário deverá consentir com as disposições contidas na respectiva Política de Privacidade a ser apresentada a todos os interessados dentro da interface da plataforma.

                               `}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancelTerms} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={handleCloseTerms}
                onChange={onChangeTerms}
                color="primary"
              >
                Aceitar
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={isInvite}
            onClose={() => {}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Para aceitar o convite é preciso deslogar o usuario conectado
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => history.push('/home')} color="secondary">
                Continuar
              </Button>
              <Button onClick={handleLogout} color="primary">
                Deslogar
              </Button>
            </DialogActions>
          </Dialog>

          {showSend && (
            <FormGroup>
              <Button
                className={classes.buttonPrimary}
                color="primary"
                variant="contained"
                type="submit"
                size="large"
              >
                {' '}
                Cadastrar{' '}
              </Button>
            </FormGroup>
          )}

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={open}
            autoHideDuration={6000}
          >
            <Alert severity="success">Ação Submetida com Sucesso!</Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={openError}
            onClose={handleClose}
            autoHideDuration={3000}
          >
            <Alert severity="error">
              Erro ao submeter ação! Tente novamente.
            </Alert>
          </Snackbar>

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={openCancelar}
            autoHideDuration={2500}
            onClose={handleClose}
          >
            <Alert severity="error">
              Leia e aceite os Termos para continuar o cadastro
            </Alert>
          </Snackbar>
        </form>
        <hr />
        <Link to="/signin"> Fazer Login </Link>
      </Container>
    </div>
  );
}

export default withRouter(ConfirmInvite);
